import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../context/TranslationContext";

const FitnessSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslate("fitnessSection");

  return (
    <section className="my-sm-5 my-4 success-stories">
      <div className="container">
        <div className="row text-center">
          <div className="col-12">
            <h2 className="gallery-title text-uppercase text-white mb-3">
              {t("title")}
            </h2>
            <p className="mb-4 p-lg l-grey-text">{t("subtitle")}</p>
          </div>
        </div>

        <div className="row mt-2 justify-content-center align-items-stretch g-4 px-4">
          {/* Card 1: Fitness Calculators */}
          <div className="col-lg-3 col-md-6 col-sm-10 d-flex">
            <div
              className="text-center align-items-center p-4 rounded w-100 d-flex flex-column"
              style={{ transition: "transform 0.2s ease-in-out" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow =
                  "0 3px 16px var(--primaryMColor)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <i
                className="fas fa-heartbeat mb-3"
                style={{ color: "#4e13b6", fontSize: "80px" }}
              ></i>
              <h4 className="text-uppercase mt-3">{t("calcTitle")}</h4>
              <p className="text-secondary mb-3" style={{ fontSize: "1.1em" }}>
                {t("calcDesc")}
              </p>
              <div className="mt-auto">
                <button
                  onClick={() => navigate("/calculators")}
                  className="site-btn"
                >
                  {t("calcBtn")}
                </button>
              </div>
            </div>
          </div>

          {/* Card 2: Fitness Test */}
          <div className="col-lg-3 col-md-6 col-sm-10 d-flex">
            <div
              className="text-center align-items-center p-4 rounded w-100 d-flex flex-column"
              style={{ transition: "transform 0.2s ease-in-out" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow =
                  "0 3px 16px var(--primaryMColor)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <i
                className="fas fa-clipboard-list mb-3"
                style={{ color: "#4e13b6", fontSize: "80px" }}
              ></i>
              <h4 className="text-uppercase mt-3">{t("testTitle")}</h4>
              <p className="text-secondary mb-3" style={{ fontSize: "1.1em" }}>
                {t("testDesc")}
              </p>
              <div className="mt-auto">
                <button
                  onClick={() => navigate("/fitness-test")}
                  className="site-btn"
                >
                  {t("testBtn")}
                </button>
              </div>
            </div>
          </div>

          {/* Card 3: Traineego Community */}
          <div className="col-lg-3 col-md-6 col-sm-10 d-flex">
            <div
              className="text-center align-items-center p-4 rounded w-100 d-flex flex-column"
              style={{ transition: "transform 0.2s ease-in-out" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow =
                  "0 3px 16px var(--primaryMColor)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <i
                className="fas fa-users mb-3"
                style={{ color: "#4e13b6", fontSize: "80px" }}
              ></i>
              <h4 className="text-uppercase mt-3">{t("communityTitle")}</h4>
              <p className="text-secondary mb-3" style={{ fontSize: "1.1em" }}>
                {t("communityDesc")}
              </p>
              <div className="mt-auto">
                <button
                  onClick={() => navigate("/community")}
                  className="site-btn"
                >
                  {t("communityBtn")}
                </button>
              </div>
            </div>
          </div>

          {/* Card 4: Traineego Planner */}
          <div className="col-lg-3 col-md-6 col-sm-10 d-flex">
            <div
              className="text-center align-items-center p-4 rounded w-100 d-flex flex-column"
              style={{ transition: "transform 0.2s ease-in-out" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow =
                  "0 3px 16px var(--primaryMColor)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <i
                className="fas fa-calendar-alt mb-3"
                style={{ color: "#4e13b6", fontSize: "80px" }}
              ></i>
              <h4 className="text-uppercase mt-3">{t("plannerTitle")}</h4>
              <p className="text-secondary mb-3" style={{ fontSize: "1.1em" }}>
                {t("plannerDesc")}
              </p>
              <div className="mt-auto">
                <button
                  onClick={() => navigate("/sustainable-planner")}
                  className="site-btn"
                >
                  {t("plannerBtn")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FitnessSection;
